var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99961 0.326561C6.11628 0.326561 6.22861 0.347561 6.33661 0.389561C6.44528 0.430894 6.54128 0.493228 6.62461 0.576562L11.1246 5.07656C11.2746 5.22656 11.3496 5.40156 11.3496 5.60156C11.3496 5.80156 11.2746 5.97656 11.1246 6.12656C10.9746 6.27656 10.7996 6.35156 10.5996 6.35156C10.3996 6.35156 10.2246 6.27656 10.0746 6.12656L5.99961 2.05156L1.92461 6.12656C1.77461 6.27656 1.59961 6.35156 1.39961 6.35156C1.19961 6.35156 1.02461 6.27656 0.874609 6.12656C0.724609 5.97656 0.649609 5.80156 0.649609 5.60156C0.649609 5.40156 0.724609 5.22656 0.874609 5.07656L5.37461 0.576561C5.45794 0.493228 5.55361 0.430894 5.66161 0.389561C5.77028 0.347561 5.88294 0.326561 5.99961 0.326561Z",
    fill: "#4D4184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow_up_icon.feb6316932fdc0dee5e526bf04662ea3.svg";
export { ForwardRef as ReactComponent };